import { graphql } from "gatsby";
// import useVariation from "../../hooks/useVariation";
// import HomepageTemplate from "../../components/templates/homepage.old";
import HomepageTemplateNew from "../../components/templates/homepage.new";
import PageSEO from "../../components/seo/Page";

const Index = (props) => {
  // const homepageFlag = useVariation("homepage", { enabled: false });

  const { data, offset, pageContext } = props;
  const { contentfulHomePage } = data;
  const { modules, footnotes, socialImage, pageTitle, pageDescription } =
    contentfulHomePage;
  const { currency } = pageContext;

  const seo = {
    pagePath: "",
    title: pageTitle,
    description: pageDescription,
    image: {
      url: socialImage.file.url,
      width: socialImage.file.details.image.width,
      height: socialImage.file.details.image.height,
    },
  };

  // if (homepageFlag.enabled)
  return (
    <>
      <PageSEO {...seo} />
      <HomepageTemplateNew
        offset={offset}
        modules={modules}
        footnotes={footnotes}
        currency={currency}
      />
    </>
  );

  // return <HomepageTemplate {...props} />;
};

export default Index;

export const pageQuery = graphql`
  fragment ProductBundleFragment on ContentfulProductBundle {
    title
    slug
    labels
    shopDescription
    shopImages {
      title
      gatsbyImageData(
        layout: CONSTRAINED
        placeholder: DOMINANT_COLOR
        width: 912
        quality: 90
      )
      description
    }
    products {
      sku
      stockStatus
      name {
        name
        childMarkdownRemark {
          html
        }
      }
      headerDescription
      heroFeaturedImages {
        title
        gatsbyImageData(
          layout: CONSTRAINED
          placeholder: DOMINANT_COLOR
          width: 555
          quality: 90
        )
        description
      }
      supplementFacts {
        simpleIngredients {
          name
          dosage
          description
        }
      }
    }
  }

  query HomePageQuery($locale: String!) {
    contentfulHomePage(
      node_locale: { eq: $locale }
      contentful_id: { eq: "6jLz5EhYUoiwGqKUmQgAms" }
    ) {
      pageTitle
      pageDescription
      socialImage {
        file {
          details {
            image {
              width
              height
            }
          }
          url
        }
      }
      featuredArea1 {
        childMarkdownRemark {
          html
        }
      }
      featuredArea1Image {
        file {
          url
        }
        gatsbyImageData(
          layout: CONSTRAINED
          placeholder: DOMINANT_COLOR
          width: 570
          quality: 90
        )
        description
      }
      featuredArea1BackgroundColor
      featuredArea2 {
        childMarkdownRemark {
          html
        }
      }
      featuredArea2Image {
        file {
          url
        }
        gatsbyImageData(
          layout: CONSTRAINED
          placeholder: DOMINANT_COLOR
          width: 570
          quality: 90
        )
        description
      }
      featuredArea2BackgroundColor
      featuredArea3 {
        childMarkdownRemark {
          html
        }
      }
      featuredArea3List
      featuredArea3Image {
        file {
          url
        }
        gatsbyImageData(
          layout: CONSTRAINED
          placeholder: DOMINANT_COLOR
          width: 570
          quality: 90
        )
        description
      }
      featuredArea3BackgroundColor
      merchandisingOption
      products {
        contentful_id
        name {
          name
        }
        summary
        slug
        sku
        path
        stockStatus
        productSubhead
        shopImages {
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 1200
            quality: 90
          )
          description
        }
        ritualProduct {
          product_id
          sku
          in_stock
          ritualPlans {
            plan_id
            amount
            billing_type
            currency
            interval_count
            base_price
          }
        }
      }
      bundles {
        contentful_id
        title
        buildBundlePdp
        slug
        labels
        ritualProductOffer {
          product_offer_id
          name
          ritualProductOfferPlans {
            product_offer_plan_id
            ritualInitialPlan {
              amount
              plan_id
              currency
            }
            ritualFuturePlan {
              amount
              plan_id
              currency
            }
          }
        }
        shortDescription: description
        featuredImage {
          gatsbyImageData(
            layout: CONSTRAINED
            placeholder: DOMINANT_COLOR
            width: 1200
            quality: 90
          )
          description
        }
        products {
          name {
            name
          }
          shortDescription
          sku
          image: cartImage {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              width: 400
              quality: 90
            )
            description
          }
          supplementFacts {
            simpleIngredients {
              name
            }
            servingsPerContainer
            servingSize
          }
        }
      }
      instagramImages {
        title
        description
        gatsbyImageData(
          layout: FIXED
          placeholder: DOMINANT_COLOR
          width: 270
          height: 270
          quality: 90
        )
      }
      modules {
        type
        placement
        headline {
          childMarkdownRemark {
            html
          }
        }
        subhead {
          childMarkdownRemark {
            html
          }
        }
        links {
          text
          to {
            ... on ContentfulNavigationPath {
              path
            }
            ... on ContentfulPageVariation {
              slug
            }
          }
        }
        reviews {
          rating
          reviewContent {
            childMarkdownRemark {
              html
            }
          }
          author
          product {
            name {
              name
            }
            path
          }
        }
        backgroundColor
        textColor
        image {
          gatsbyImageData(
            layout: CONSTRAINED
            width: 1200
            quality: 90
            cropFocus: CENTER
          )
          description
        }
        imageMobile {
          gatsbyImageData(layout: CONSTRAINED, width: 900, quality: 90)
          description
        }
        video {
          ...videoContent
        }
        videoMobile {
          ...videoContent
        }
        valueProps {
          name
          disclaimer
          icon {
            file {
              url
              fileName
              details {
                image {
                  height
                  width
                }
              }
            }
          }
        }
        experts {
          contentful_id
          name
          title
          image {
            title
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              width: 600
              quality: 90
            )
          }
        }
        productCategories {
          shortName
          contentful_id
          cardImage {
            title
            description
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              width: 580
              quality: 90
            )
          }
          backgroundColor
          shopLandingReference {
            ... on ContentfulPageVariation {
              slug
            }
          }
        }
        media {
          ... on ContentfulVideoContent {
            ...videoContent
          }
          ... on ContentfulImageContent {
            title
            alt
            image {
              gatsbyImageData(layout: CONSTRAINED, width: 580, quality: 90)
            }
          }
        }
        products {
          contentful_id
          name {
            name
          }
          summary
          slug
          sku
          path
          stockStatus
          productSubhead
          shopImages {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              width: 1200
              quality: 90
            )
            description
          }
          ritualProduct {
            product_id
            sku
            in_stock
            ritualPlans {
              plan_id
              amount
              billing_type
              currency
              interval_count
              base_price
            }
          }
        }
      }
      footnotes {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`;
